import type { ConceptDef } from '../types';

export const countOn: ConceptDef = {
  kind: 'tileMatch',
  id: 'count-on',
  label: 'Count On',
  category: 'Math',
  description: 'Hear a starting number and a count; tap the result.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Start at 1, plus 2.', answer: '3' },
      { say: 'Start at 2, plus 2.', answer: '4' },
      { say: 'Start at 3, plus 2.', answer: '5' },
      { say: 'Start at 4, plus 2.', answer: '6' },
      { say: 'Start at 5, plus 2.', answer: '7' },
      { say: 'Start at 6, plus 2.', answer: '8' },
    ],
  },
};
